import React, { useState } from 'react';
import {
  Dialog, DialogActions, DialogContent, DialogContentText,
  DialogTitle, TextField, Button
} from '@mui/material';

const UnsuccessfulRequestDialog = ({ open, onClose, onSubmit }) => {
  const [reason, setReason] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleSubmit = async () => {
    if (!reason.trim()) {
      return;
    }
    setIsSubmitting(true);
    try {
      await onSubmit(reason);
      handleClose();
    } catch (error) {
      console.error("Error submitting Unsuccessful request:", error);
    } finally {
      setIsSubmitting(false);
    }
  };

  const handleClose = () => {
    setReason('');
    onClose();
  };

  return (
    <Dialog open={open} onClose={handleClose}>
      <DialogTitle>Request Unsuccessful Completion</DialogTitle>
      <DialogContent>
        <DialogContentText sx={{ mb: 2 }}>
          Please provide a reason why this job could not be completed successfully. This will be sent for approval.
        </DialogContentText>
        <TextField
          autoFocus
          margin="dense"
          id="unsuccessful-reason"
          label="Reason"
          type="text"
          fullWidth
          variant="outlined"
          multiline
          rows={3}
          value={reason}
          onChange={(e) => setReason(e.target.value)}
          required
        />
      </DialogContent>
      <DialogActions>
        <Button onClick={handleClose} disabled={isSubmitting}>Cancel</Button>
        <Button
          onClick={handleSubmit}
          variant="contained"
          color="primary"
          disabled={!reason.trim() || isSubmitting}
        >
          {isSubmitting ? 'Submitting...' : 'Submit Request'}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default UnsuccessfulRequestDialog;